import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=80f2e5f2&scoped=true&"
var script = {}
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=80f2e5f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f2e5f2",
  null
  
)

export default component.exports